/* eslint-disable prefer-regex-literals */
import * as yup from 'yup';

export const phoneRegExp = /^(\+\d{1,3}[- ]?)?\d{10}$/;
const stripHtml = (html: string | null | undefined): string => {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
};

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email('Địa chỉ email không hợp lệ')
    .max(255, 'Nhập tối đa 255 ký tự')
    .required('Địa chỉ email là bắt buộc'),
  password: yup.string().required('Mật khẩu là bắt buộc'),
  otpCode: yup
    .string()
    .matches(new RegExp('^[0-9]+$'), { message: 'OTP phải là số' })
    .length(6, 'OTP phải có 6 chữ số'),
});

export const forgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .email('Địa chỉ email không hợp lệ')
    .max(255, 'Nhập tối đa 255 ký tự')
    .required('Địa chỉ email là bắt buộc'),
});

export const detailPageSchema = yup.object().shape({
  title: yup.string().required('Trường này là bắt buộc'),
  slug: yup.string().required('Trường này là bắt buộc'),
  seoTitle: yup.string(),
});

export const menuGenerationForm = yup.object().shape({
  title: yup.number().required('Trường này là bắt buộc'),
  target: yup.number().required('Trường này là bắt buộc'),
});

export const menuGenerationForm2 = yup.object().shape({
  title: yup.string().required('Trường này là bắt buộc'),
  target: yup.number().required('Trường này là bắt buộc'),
});

export const detailPageHeaderSchema = yup.object().shape({
  sample: yup.string().required('Hãy chọn một mẫu'),
  parent: yup.number(),
  state: yup.number(),
  isHome: yup.boolean(),
});

const blockSectionObj = {
  name: yup.string(),
  description: yup.string(),
  content: yup.string(),
  ogImage: yup.object().nullable(),
  link: yup.string(),
  url: yup.string(),
  target: yup.object().nullable(),
};

const mediaSocialObj = {
  ogTitle: yup.string(),
  ogDescription: yup.string(),
  ogType: yup.number().required('Chọn 1 mạng xã hội'),
  ogImage: yup.object().nullable(),
};

export const seoSectionSchema = yup.object().shape({
  seoTitle: yup.string(),
  seoIntro: yup.string(),
  seoKeyword: yup.string(),
  metaViewPort: yup.string(),
  metaRobot: yup.string(),
  canonicalURL: yup.string(),
  structuredData: yup.string(),
  ogImage: yup.object().nullable(),
  mediaSocial: yup.array().of(yup.object().shape(mediaSocialObj)),
});

export const openGraphSectionSchema = yup.object().shape({
  ogTitle: yup.string(),
  ogType: yup.string(),
  ogImage: yup.object().nullable(),
});

export const blockSectionSchema = yup.object().shape({
  sectionTitle: yup.string(),
  blockSection: yup.array().of(yup.object().shape(blockSectionObj)),
});

export const commentSectionSchema = yup.object().shape({
  comment: yup.string(),
});

export const menuCreateSchema = yup.object().shape({
  title: yup.string().required('Điền tiêu đề menu'),
  code: yup.string().required('Điền mã code cho menu'),
});

export const templateEditSchema = yup.object().shape({
  title: yup.string().required('Điền tiêu đề trang mẫu'),
});

export const bannerCreateSchema = yup.object().shape({
  name: yup.string().required('Điền tên banner'),
  items: yup.array().of(
    yup.object().shape({
      type: yup.string(),
      data: yup.object().when('type', {
        is: 'video',
        then: (schema) => schema.shape({
          videoType: yup.string().required('Vui lòng chọn loại'),
          videoUrl: yup.string().required('Thông tin bắt buộc'),
          videoThumbnail: yup.string().required('Thông tin bắt buộc'),
        }),
      }),
    })
  ),
});

export const pageDetailMainData = yup.object().shape({
  title: yup.string().required('Điền tiêu đề trang'),
  slug: yup.string().required('Điền đường dẫn trang'),
});

export const redirectFormSchema = yup.object().shape({
  from: yup.string().required('Thông tin bắt buộc'),
  to: yup.string().required('Thông tin bắt buộc'),
});

export const roleFormSchema = yup.object().shape({
  displayName: yup.string().required('Thông tin bắt buộc'),
});

export const userFormSchema = yup.object().shape({
  name: yup.string().required('Thông tin bắt buộc'),
  email: yup
    .string()
    .email('Địa chỉ email không hợp lệ')
    .max(255, 'Nhập tối đa 255 ký tự')
    .required('Địa chỉ email là bắt buộc'),
  password: yup
    .string()
    .notRequired()
    .test('password', 'Mật khẩu ít nhất 6 kí tự', (value) => {
      if (value) {
        const schema = yup.string().min(6);
        return schema.isValidSync(value);
      }
      return true;
    }),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Mật khẩu xác nhận không khớp'),
  roles: yup.array().min(1, 'Chọn ít nhất 1 quyền'),
});

// Reusable thumbnail schema
const thumbnailSchema = yup.object({
  path: yup.string().nullable(),
  alt: yup.string().nullable(),
  title: yup.string().nullable().max(100, 'Tiêu đề ảnh không quá 100 ký tự'),
});

// Story Hook
const storyHookSchema = yup.object({
  title: yup.string()
    .nullable()
    .max(80, 'Tiêu đề không vượt quá 80 ký tự'),
  description: yup.string()
    .nullable()
    .test(
      'plain-text-length',
      'Nội dung phần mở đầu không được vượt quá 500 ký tự',
      (value) => !value || stripHtml(value).length <= 500
    ),
  thumbnail: thumbnailSchema.nullable(),
});

// Problem & Solution Blocks (items[])
const blockItemSchema = yup.object({
  title: yup.string()
    .nullable()
    .max(80, 'Tiêu đề không vượt quá 80 ký tự'),
  description: yup.string()
    .nullable()
    .test(
      'plain-text-length',
      'Nội dung không được vượt quá 400 ký tự',
      (value) => !value || stripHtml(value).length <= 400
    ),
  thumbnail: thumbnailSchema.nullable(),
});

// Summary Items (new field: subTitle)
const summaryItemSchema = yup.object({
  title: yup.string()
    .nullable()
    .max(100, 'Tiêu đề không vượt quá 100 ký tự'),
  subTitle: yup.string()
    .nullable()
    .max(150, 'Phụ đề không vượt quá 150 ký tự'),
  description: yup.string()
    .nullable()
    .test(
      'plain-text-length',
      'Nội dung tóm tắt không được vượt quá 300 ký tự',
      (value) => !value || stripHtml(value).length <= 300
    ),
  thumbnail: thumbnailSchema.nullable(),
});

// Conclusion
const conclusionSchema = yup.object({
  title: yup.string()
    .nullable()
    .max(100, 'Tiêu đề kết luận không vượt quá 100 ký tự'),
  description: yup.string()
    .nullable()
    .test(
      'plain-text-length',
      'Nội dung kết luận không được vượt quá 500 ký tự',
      (value) => !value || stripHtml(value).length <= 500
    ),
  thumbnail: thumbnailSchema.nullable(),
});

// Final Metadata Schema
export const metadataSchema = yup.object({
  botKey: yup.string().nullable(),
  bannerId: yup.number().required('Cập nhật banner'),

  storyHook: storyHookSchema.nullable(),

  items: yup.array()
    .of(blockItemSchema)
    .min(1, 'Cần có ít nhất 1 khối nội dung (vấn đề/giải pháp)')
    .nullable(),

  summary: yup.object({
    title: yup.string()
      .nullable()
      .max(150, 'Tiêu đề phần tóm tắt không quá 150 ký tự'),

    rows: yup.array()
      .of(summaryItemSchema)
      .min(1, 'Cần có ít nhất 1 hàng trong phần tóm tắt')
      .nullable(),
  }),

  conclusion: conclusionSchema.nullable(),
});

export const updateNewsByIdSchema = yup.object().shape({
  displayOrder: yup.number().required('Nhập thứ tự hiển thị'),
  title: yup.string().required('Nhập tiêu đề').test(
    'max-words',
    'Tiêu đề không được vượt quá 90 từ',
    (value) => !value || value.trim().split(/\s+/).filter(Boolean).length <= 90
  ).max(90, 'Tiêu đề không quá 90 ký tự'),
  slug: yup.string().required('Nhập đường dẫn'),
  description: yup.string().required('Nhập mô tả'),
  content: yup.string().required('Nhập nội dung'),
  thumbnail: yup.string().required('Cập nhật hình ảnh'),
});

export const updateBlogByIdSchema = yup.object().shape({
  displayOrder: yup.number().required('Nhập thứ tự hiển thị'),
  title: yup.string().required('Nhập tiêu đề').test(
    'max-words',
    'Tiêu đề không được vượt quá 90 từ',
    (value) => !value || value.trim().split(/\s+/).filter(Boolean).length <= 90
  ).max(90, 'Tiêu đề không quá 90 ký tự'),
  slug: yup.string().required('Nhập đường dẫn'),
  description: yup.string().required('Nhập mô tả'),
  content: yup.string().required('Nhập nội dung'),
  thumbnail: yup.string().required('Cập nhật hình ảnh'),
  botkey: yup.string().nullable(),
  blogData: metadataSchema.nullable()
});

export const updateNewsCategoriesByIdSchema = yup.object().shape({
  displayOrder: yup.number().required('Nhập thứ tự hiển thị'),
  name: yup.string().required('Nhập tiêu đề'),
  slug: yup.string().required('Nhập đường dẫn'),
  description: yup.string().required('Nhập mô tả'),
});

export const updateCategoryFaqByIdSchema = yup.object().shape({
  displayOrder: yup.number().required('Nhập thứ tự hiển thị'),
  name: yup.string().required('Nhập tiêu đề'),
  slug: yup.string().required('Nhập đường dẫn'),
  description: yup.string().required('Nhập mô tả'),
});

export const updateFaqByIdSchema = yup.object().shape({
  answer: yup.string().required('Nhập câu hỏi'),
  question: yup.string().required('Nhập câu trả lời'),
  faqCategoryId: yup.array().required('Chọn danh mục'),
});

export const updateContactProblemSchema = yup.object().shape({
  name: yup.string().required('Nhập tên'),
});

export const updateProfileSchema = yup.object().shape({
  name: yup.string().required('Trường này là bắt buộc'),
  email: yup
    .string()
    .email('Địa chỉ email không hợp lệ')
    .max(255, 'Nhập tối đa 255 ký tự')
    .required('Trường này là bắt buộc'),
  password: yup.string().required('Trường này là bắt buộc'),
});

export const changePasswordSchema = yup.object().shape({
  oldPassword: yup.string().required('Trường này là bắt buộc'),
  newPassword: yup
    .string()
    .min(6)
    .required('Trường này là bắt buộc')
    .notOneOf(
      [yup.ref('oldPassword')],
      'Mật khẩu mới không được trùng mật khẩu cũ'
    )
    .min(6, 'Mật khẩu phải ít nhất 6 kí tự'),
  newPasswordConfirm: yup
    .string()
    .required('Trường này là bắt buộc')
    .oneOf([yup.ref('newPassword')], 'Mật khẩu xác nhận không khớp'),
});

export const updateEmailTemplateSchema = yup.object().shape({
  name: yup.string().required('Nhập tên'),
  subject: yup.string().required('Nhập tiêu đề'),
  content: yup.string().required('Nhập nội dung'),
});

export const activeTOtpSecretSchema = yup.object().shape({
  currentPassword: yup.string().required('Trường này là bắt buộc'),
  otpCode: yup
    .string()
    .matches(new RegExp('^[0-9]+$'), { message: 'OTP phải là số' })
    .length(6, 'OTP phải có 6 chữ số')
    .required('Trường này là bắt buộc'),
});

export const requiredPasswordSchema = yup.object().shape({
  currentPassword: yup.string().required('Trường này là bắt buộc'),
});

export const staticBlocksMainData = yup.object().shape({
  name: yup.string().required('Trường này là bắt buộc'),
  templateCode: yup.string().required('Trường này là bắt buộc'),
});

export const customerSchema = yup.object().shape({
  name: yup.string().required('Trường này là bắt buộc'),
  phone: yup
    .string()
    .matches(phoneRegExp, 'Số điện thoại không hợp lệ')
    .required('Trường này là bắt buộc'),
  primaryEmail: yup
    .string()
    .email('Định dạng email không hợp lệ.')
    .max(255, 'Nhập tối đa 255 ký tự')
    .required('Địa chỉ email là bắt buộc'),
  client: yup.object().shape({
    value: yup.number().required('Trường này là bắt buộc'),
  }),
});

export const clientSchema = yup.object().shape({
  name: yup
    .string()
    .max(50, 'Nhập tối đa 50 ký tự')
    .required('Thiếu thông tin bắt buộc.'),
  taxCode: yup.string().required('Thiếu thông tin bắt buộc.'),
  contractNumber: yup.string(),
  dateRange: yup.array().nullable().required('Thiếu thông tin bắt buộc.'),
  corporateAccountName: yup
    .string()
    .max(50, 'Nhập tối đa 50 ký tự')
    .required('Thiếu thông tin bắt buộc.'),
  corporateAccountMail: yup
    .string()
    .email('Định dạng email không hợp lệ.')
    .max(55, 'Nhập tối đa 55 ký tự')
    .required('Địa chỉ email là bắt buộc'),
  corporateAccountPhone: yup
    .string()
    .matches(phoneRegExp, { message: 'Số điện thoại không hợp lệ', excludeEmptyString: true })
    .required('Thiếu thông tin bắt buộc.'),
  technicalSupportName: yup
    .string()
    .max(50, 'Nhập tối đa 50 ký tự'),
  technicalSupportMail: yup
    .string()
    .email('Định dạng email không hợp lệ.')
    .max(55, 'Nhập tối đa 55 ký tự'),
  package: yup.object().shape({
    value: yup.number().required('Trường này là bắt buộc'),
  }),
  isUseDuoKnowledgeBase: yup.boolean(),
  knowledgeUseCase: yup.object().when('isUseDuoKnowledgeBase', {
    is: true,
    then: (schema) => schema.shape({
      value: yup.number().required('Thiếu thông tin bắt buộc.'),
    }),
  }).nullable(),
});

export const packageDetailSchema = yup.object().shape({
  name: yup
    .string()
    .matches(/^[A-Za-zÀ-ỹà-ỹĀ-žƀ-ƶƸ-ȳ]+$/, 'Tên gói không hợp lệ')
    .max(30, 'Nhập tối đa 30 ký tự')
    .required('Trường này là bắt buộc'),
  basePrice: yup.number().required('Trường này là bắt buộc'),
  duration: yup
    .number()
    .transform((value, originalValue) => {
      if (typeof originalValue === 'number') return originalValue;

      if (
        originalValue
        && typeof originalValue === 'object'
        && 'value' in originalValue
      ) {
        return originalValue.value;
      }

      return undefined;
    })
    .required('Trường này là bắt buộc')
    .typeError('Trường này là bắt buộc'),
  isApplyPayg: yup.boolean().required('Trường này là bắt buộc'),
  tiers: yup.array().of(
    yup.object().shape({
      numberOfAgent: yup.number(),
      knowledges: yup.array().of(yup.number()),
      knowledgeLimits: yup.object().shape({
        numberOfFile: yup.number(),
        fileSizeLimit: yup.number(),
        totalSizeLimit: yup.number(),
        numberOfWeb: yup.number(),
      }),
      customServices: yup.array().of(yup.string()),
      endUserSides: yup.object().shape({
        numberOfSession: yup.number(),
        chatUpload: yup.boolean(),
        agentTypeBoth: yup.boolean(),
      }),
      price: yup.number(),
    })
  ),
});

export const addOnPackageDetailSchema = yup.object().shape({
  name: yup
    .string()
    .matches(/^[A-Za-zÀ-ỹà-ỹĀ-žƀ-ƶƸ-ȳ\s]+$/, 'Tên gói không hợp lệ')
    .max(30, 'Nhập tối đa 30 ký tự')
    .required('Trường này là bắt buộc'),
  duration: yup
    .number().transform((value, originalValue) => {
      if (typeof originalValue === 'number') return originalValue;

      if (
        originalValue
        && typeof originalValue === 'object'
        && 'value' in originalValue
      ) {
        return originalValue.value;
      }

      return undefined;
    }).required('Trường này là bắt buộc'),
  addOnType: yup
    .number().required('Trường này là bắt buộc'),
  numberOfAgent: yup.number().required('Trường này là bắt buộc').min(1, 'Phải lớn hơn 0'),
  numberOfFile: yup.number().required('Trường này là bắt buộc').min(1, 'Phải lớn hơn 0'),
  totalSizeLimit: yup.number().required('Trường này là bắt buộc').min(1, 'Phải lớn hơn 0'),
  numberOfWebite: yup.number().required('Trường này là bắt buộc').min(1, 'Phải lớn hơn 0'),
  numberOfSession: yup.number().required('Trường này là bắt buộc').min(1, 'Phải lớn hơn 0'),
  price: yup.number().required('Trường này là bắt buộc').min(1000, 'Phải lớn hơn 1000'),
});
